import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { UiButtonLinkTo } from 'teacher-ui-client/components/ui-button/link-to'
import { t } from 'ember-intl'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { array, concat } from '@ember/helper'

interface Args {
  chartRoute?: string
  routePrefix?: string
  studentId?: string | null
  tableRoute?: string
}

interface Signature {
  Args: Args
  Element: HTMLDivElement
}

export const ReportingTableOrChartSelector: TOC<Signature> = <template>
  <div class="inline-flex" data-test-table-or-chart-selector-container ...attributes>
    <UiButtonLinkTo
      data-test-table-or-chart-selector="chart"
      class="rounded-r-none"
      @appearance={{ButtonAppearance.mutedWithActive}}
      @route={{if @chartRoute @chartRoute (concat @routePrefix ".index")}}
      @models={{if @studentId (array @studentId)}}
    >
      <PhosphorIcon @icon="phosphor-chart-line-bold" />
      {{t "chart"}}
    </UiButtonLinkTo>
    <UiButtonLinkTo
      data-test-table-or-chart-selector="table"
      class="rounded-l-none"
      @appearance={{ButtonAppearance.mutedWithActive}}
      @route={{if @tableRoute @tableRoute (concat @routePrefix ".table")}}
      @models={{if @studentId (array @studentId)}}
    >
      <PhosphorIcon @icon="phosphor-list-bullets-bold" />
      {{t "table"}}
    </UiButtonLinkTo>
  </div>
</template>

export default ReportingTableOrChartSelector
